import LoginWithEmail from '@features/auth/components/LoginWithEmail';
import GuardedRoute from '@features/layout/components/GuardedRoute';
import { IGetServerSideProps } from 'model/global.model';
import { GetServerSideProps } from 'next';
import Head from 'next/head';
import React from 'react';
import { useIntl } from 'react-intl';

const LoginEmail = ({ title }: IGetServerSideProps) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Head>
				<title>{formatMessage({ id: 'bcs-Title-Login' })}</title>
				<link rel='icon' href='/favicon.ico' />
				<meta
					name='viewport'
					content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no'
				/>
				<meta name='theme-color' content='#ffffff' />
				<meta property='og:title' content={title} key='ogTitle' />
			</Head>
			<GuardedRoute redirectTo={'/'} isAuthenticationRoute>
				<LoginWithEmail />
			</GuardedRoute>
		</>
	);
};

export const getServerSideProps: GetServerSideProps = async () => {
	return {
		props: {
			title: 'Вход | Gamy.fun',
		},
	};
};

export default LoginEmail;
